const SimpleLightbox = require('simple-lightbox');

function handleLink(e) {
    const iframe = global.quietmark.video.create(e.currentTarget.href, 854, 480);
    if (iframe === false) return;

    e.preventDefault();
    e.stopPropagation();

    SimpleLightbox.open({
        content: iframe,
        elementClass: 'js-lightbox',
        closeBtnClass: 'product__lightbox__close',
    });
}

document.querySelectorAll('.js-video-lightbox-link').forEach((link) => {
    link.addEventListener('click', handleLink);
    link.addEventListener('tap', handleLink);
});
